import { StickyFooterProvider } from 'providers/StickyFooterProvider/StickyFooterProvider'
import { FooterButtons, StickyFooter } from 'components/FirstTimeExperienceModal/components/Footer/Footer'
import { Button } from 'blaze-ui/Button'
import useResponsiveDesign from 'hooks/useResponsiveDesign'

interface V4StepFooterProps {
  onBack: () => void
  onNext: () => void
  isSaving?: boolean
  isDisabled?: boolean
  nextLabel?: string
  savingLabel?: string
  alwaysShowBack?: boolean
  hideBack?: boolean
  children: React.ReactNode
}

export const V4StepFooter = ({
  onBack,
  onNext,
  isSaving = false,
  isDisabled = false,
  nextLabel = 'Continue',
  savingLabel = 'Saving...',
  alwaysShowBack = false,
  hideBack = false,
  children,
}: V4StepFooterProps) => {
  const { isMobile } = useResponsiveDesign()

  return (
    <StickyFooterProvider
      footer={
        <StickyFooter>
          <FooterButtons>
            {!hideBack && (alwaysShowBack || !isMobile) ? (
              <Button variant="tertiary" size="lg" onPress={onBack}>
                Back
              </Button>
            ) : (
              !isMobile && <span />
            )}
            <Button size="lg" onPress={onNext} isDisabled={isSaving || isDisabled} fullWidth={isMobile}>
              {isSaving ? savingLabel : nextLabel}
            </Button>
          </FooterButtons>
        </StickyFooter>
      }
    >
      {children}
    </StickyFooterProvider>
  )
}
